import { apiFetch } from './api';

export interface CreditHistoryItem {
  id: string;
  agentId: string;
  agentName: string;
  month: string;
  used: number;
}

export interface MonthlyCreditHistoryGrouped {
  month: string;
  monthFormatted: string;
  monthDisplay: string;
  totalUsed: number;
  agentDetails: {
    id: string;
    agentId: string;
    used: number;
    agentName: string;
  }[];
}

export interface OrganizationCredits {
  credit: number;
  usedThisMonth: number;
  extraCredits: number;
  totalAvailableCredits: number;
}

export interface AgentCreditUsage {
  agentId: string;
  usedThisMonth: number;
  monthlyHistory: {
    month: string;
    monthDisplay: string;
    used: number;
  }[];
}

export const creditApi = {
  async getOrganizationCredits(): Promise<OrganizationCredits> {
    try {
      return await apiFetch<OrganizationCredits>('/CreditHistory/GetOrganizationCredits', { auth: true });
    } catch (error) {
      console.error('Error fetching organization credits:', error);
      throw error;
    }
  },

  async getMonthlyCreditHistory(): Promise<CreditHistoryItem[]> {
    try {
      return await apiFetch<CreditHistoryItem[]>('/CreditHistory/GetMonthlyCreditHistory', { auth: true });
    } catch (error) {
      console.error('Error fetching monthly credit history:', error);
      throw error;
    }
  },

  async getCreditHistory(): Promise<CreditHistoryItem[]> {
    try {
      return await apiFetch<CreditHistoryItem[]>('/CreditHistory/GetAllHistories', { auth: true });
    } catch (error) {
      console.error('Error fetching credit history:', error);
      throw error;
    }
  },

  async getMonthlyCreditHistoryGrouped(): Promise<MonthlyCreditHistoryGrouped[]> {
    try {
      return await apiFetch<MonthlyCreditHistoryGrouped[]>('/CreditHistory/GetMonthlyCreditHistoryGrouped', { auth: true });
    } catch (error) {
      console.error('Error fetching monthly credit history grouped:', error);
      throw error;
    }
  },

  async getAgentCreditUsage(agentId: string): Promise<AgentCreditUsage> {
    try {
      return await apiFetch<AgentCreditUsage>(`/CreditHistory/GetAgentCreditUsage?agentId=${encodeURIComponent(agentId)}`, { auth: true });
    } catch (error) {
      console.error('Error fetching agent credit usage:', error);
      throw error;
    }
  }
};
